// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__prAoO","card":"style_card__1K2Ip","content":"style_content__O1KND"};